export class AddNewProduct {
    productCategoryId: number;
    add_comapin: boolean;
    productId: number;
    constructor (productCategoryId,add_comapin,productId) {
        this.productCategoryId = productCategoryId;
        this.add_comapin = add_comapin;
        this.productId = productId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/add-new-product.ts